<template>
  <div>
    <el-form :label-position="labelPosition" :rules="removeFormRules" label-width="80px" :model="formLabelAlign">
      <el-form-item label="步骤名称">
        <el-input v-model="formLabelAlign.name" disabled style="width: 360px;"></el-input>
      </el-form-item>
      <el-form-item label="选择群组" prop="removeGroupId">
        <el-select @change="update" filterable v-model="formLabelAlign.removeGroupId" placeholder="--请选择群组--">
          <el-option
            v-for="item in groupOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getGroupList } from '@/api/customer.js'
export default {
  name: '',
  props: ['contents'],
  data () {
    return {
      removeFormRules: {
        removeGroupId: [
          { required: true, message: '群组不能为空', trigger: 'change' }
        ]
      },
      groupOptions: [],
      labelPosition: 'right',
      formLabelAlign: this.contents,
      search: {
        type: 2
      }
    }
  },
  computed: {
  },
  methods: {
    // 传值到父组件
    update() {
      // 传值到父组件
      let choose = {}
      choose.nodeType = 'removeGroupNode'
      choose.removeGroupId = this.formLabelAlign.removeGroupId
      choose.id = this.formLabelAlign.id
      choose.name = '移除群组'
      this.$emit('change', choose)
    },
    loadGroupList() {
      getGroupList(1, this.search, '').then((res) => {
        console.log('res', res)
        this.groupOptions = res.data.data.list
      })
    }
  },
  watch: {
    contents: function (val) {
      this.formLabelAlign = val
    }
  },
  created() {
    this.loadGroupList()
    console.log('contents', this.formLabelAlign)
  }
}
</script>

<style scoped>
</style>
